module.exports = __webpack_public_path__ + "img/tmx_future.8612ae9e.jpg";